import { render, staticRenderFns } from "./RowInHostsBook.vue?vue&type=template&id=663ca9f2&scoped=true"
import script from "./RowInHostsBook.vue?vue&type=script&lang=js"
export * from "./RowInHostsBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ca9f2",
  null
  
)

export default component.exports